import { Alert } from "@mui/material";
import type { StatisticsReport } from "../../lib/types";

function operationLabel(count: number) {
  return count === 1 ? "operation" : "operations";
}

export function StatisticsAggregationWarning({ report }: { report: StatisticsReport }) {
  if (report.aggregation_complete && report.comparison_complete) return null;

  const messages = [];
  if (!report.aggregation_complete) {
    const count = report.unconverted_transaction_count;
    messages.push(`Totals are incomplete: ${count} ${operationLabel(count)} could not be converted.`);
  }
  if (!report.comparison_complete) {
    const count = report.previous_unconverted_transaction_count;
    messages.push(`Comparison is incomplete: ${count} ${operationLabel(count)} could not be converted.`);
  }

  return <Alert severity="warning" variant="outlined" className="statistics-aggregation-warning">{messages.join(" ")}</Alert>;
}
